import { render, staticRenderFns } from "./RegisterTab.vue?vue&type=template&id=75796c26"
import script from "./RegisterTab.vue?vue&type=script&lang=ts"
export * from "./RegisterTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports